export default "__VITE_ASSET__JTsXxqqy__"